// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-content__action[data-v-7c6bf81e] {\n  position: relative;\n}\n.right-content__action[data-v-7c6bf81e]::after {\n  position: absolute;\n  display: block;\n  content: '';\n  border-right: 1px #fff solid;\n  height: 14px;\n  right: 0px;\n  top: 50%;\n  margin-top: -7px;\n}\n", ""]);
// Exports
module.exports = exports;
